module.exports = __webpack_public_path__ + "img/upsort.4b048c3c.svg";